import careConfig from "@careConfig";
import { useTranslation } from "react-i18next";

import { PartnersRow } from "@/components/Common/PartnersRow";
import { WelsysFooter } from "@/components/Common/WelsysFooter";

export const AuthHero = () => {
  const { stateLogo, customLogo, appName } = careConfig;
  const customDescriptionHtml = __CUSTOM_DESCRIPTION_HTML__;
  const { t } = useTranslation();

  const logos = [stateLogo, customLogo].filter(
    (logo) => logo?.light || logo?.dark,
  );

  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-6 md:order-first md:h-full md:w-[calc(50%+130px)] md:flex-none md:p-0 md:px-16 md:pr-[calc(4rem+130px)]">
      <div></div>
      <div className="mt-4 flex flex-col items-start rounded-lg py-4 md:mt-12">
        <div className="mb-4 hidden items-center gap-6 md:flex">
          {logos.map((logo, index) =>
            logo && logo.light ? (
              <div key={index} className="flex items-center">
                <img
                  src={logo.light}
                  className="h-16 rounded-lg py-3"
                  alt="state logo"
                />
              </div>
            ) : null,
          )}
        </div>
        <div className="max-w-lg">
          <h1 className="text-4xl font-black leading-tight tracking-wider text-white lg:text-5xl">
            {appName}
          </h1>
          {customDescriptionHtml ? (
            <div className="py-6">
              <div
                className="max-w-xl text-secondary-400"
                dangerouslySetInnerHTML={{
                  __html: __CUSTOM_DESCRIPTION_HTML__,
                }}
              />
            </div>
          ) : (
            <div className="max-w-xl py-6 pl-1 text-base font-semibold text-secondary-400 md:text-lg lg:text-xl">
              {t("goal")}
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col items-start gap-4">
        <PartnersRow dark />
        <WelsysFooter />
      </div>
    </div>
  );
};
